import Aiden from '../src/assets/schoolbag/Aiden.jpg';
import Aiden1 from '../src/assets/schoolbag/Aiden1.jpg'
import AmazonBasics from '../src/assets/schoolbag/AmazonBasics.jpg';
import AmazonBasics1 from '../src/assets/schoolbag/AmazonBasics1.jpg';
import American from '../src/assets/schoolbag/American.jpg';
import American1 from '../src/assets/schoolbag/American1.jpg';
import Americantourister from '../src/assets/schoolbag/Americantourister.jpg';
import Americantourister1 from '../src/assets/schoolbag/Americantourister1.jpg';
import CasualCollege from '../src/assets/schoolbag/CasualCollege.jpg';
import CasualCollege1 from '../src/assets/schoolbag/CasualCollege1.jpg';
import FurJaden from '../src/assets/schoolbag/FurJaden.jpg';
import FurJaden1 from '../src/assets/schoolbag/FurJaden1.jpg';
import Gear from '../src/assets/schoolbag/Gear.jpg';
import Gear1 from '../src/assets/schoolbag/Gear1.jpg';
import RightChoice from '../src/assets/schoolbag/RightChoice.jpg';
import RightChoice1 from '../src/assets/schoolbag/RightChoice1.jpg';
import GearCampus from '../src/assets/schoolbag/GearCampus.jpg';
import GearCampus1 from '../src/assets/schoolbag/GearCampus1.jpg';
import GearNavyBlue from '../src/assets/schoolbag/GearNavyBlue.jpg';
import GearNavyBlue1 from '../src/assets/schoolbag/GearNavyBlue1.jpg';
import GearTriumph from '../src/assets/schoolbag/GearTriumph.jpg';
import GearTriumph1 from '../src/assets/schoolbag/GearTriumph1.jpg';
import HalfMoon from '../src/assets/schoolbag/HalfMoon.jpg';
import HalfMoon1 from '../src/assets/schoolbag/HalfMoon1.jpg';
import Japsbag from '../src/assets/schoolbag/Japsbag.jpg';
import Japsbag1 from '../src/assets/schoolbag/Japsbag1.jpg';
import KillerJupiter from '../src/assets/schoolbag/KillerJupiter.jpg';
import KillerJupiter1 from '../src/assets/schoolbag/KillerJupiter1.jpg';
import KillerPolyester from '../src/assets/schoolbag/KillerPolyester.jpg';
import KillerPolyester1 from '../src/assets/schoolbag/KillerPolyester1.jpg';
import KillerSprint from '../src/assets/schoolbag/KillerSprint.jpg';
import KillerSprint1 from '../src/assets/schoolbag/KillerSprint1.jpg';
import KillerVespa from '../src/assets/schoolbag/KillerVespa.jpg';
import KillerVespa1 from '../src/assets/schoolbag/KillerVespa1.jpg';
import safari from '../src/assets/schoolbag/safari.jpg';
import safari1 from '../src/assets/schoolbag/safari1.jpg';
import LenovoSlim from '../src/assets/schoolbag/LenovoSlim.jpg';
import LenovoSlim1 from '../src/assets/schoolbag/LenovoSlim1.jpg';
import safari2 from '../src/assets/schoolbag/safari2.jpg';
import safari3 from '../src/assets/schoolbag/safari3.jpg';
import Wesley from '../src/assets/schoolbag/Wesley.jpg';
import Wesley1 from '../src/assets/schoolbag/Wesley1.jpg';

const Sdata = [
    {
        img1:Aiden,
        img2: Aiden1,
        title:"Aiden",
        price:"350"
    },
    {
        img1: AmazonBasics,
        img2: AmazonBasics1,
        title:"Amazon Basics",
        price:"450"
    },
    {
        img1: American,
        img2: American1,
        title:"American Touister",
        price:"400"
    },
    {
        img1: Americantourister,
        img2: Americantourister1,
        title:"American Tourister",
        price:"350"
    },
    {
        img1: CasualCollege,
        img2: CasualCollege1,
        title:"Casual College",
        price:"300"
    },
    {
        img1: FurJaden,
        img2: FurJaden1,
        title:"FurJaden",
        price:"550"
    },
    {
        img1: Gear,
        img2: Gear1,
        title:"Gear",
        price:"470"
    },
    {
        img1: RightChoice,
        img2: RightChoice1,
        title:"Gear Basic",
        price:"300"
    },
    {
        img1: GearCampus,
        img2: GearCampus1,
        title:"Gear Campus",
        price:"450"
    },
    {
        img1: GearNavyBlue,
        img2: GearNavyBlue1,
        title:"Gear Navy Blue",
        price:"420"
    },
    {
        img1: GearTriumph,
        img2: GearTriumph1,
        title:"Gear Triumph",
        price:"370"
    },
    {
        img1: HalfMoon,
        img2: HalfMoon1,
        title:"Half Moon",
        price:"320"
    },
    {
        img1: Japsbag,
        img2: Japsbag1,
        title:"Japs",
        price:"450"
    },
    {
        img1: KillerJupiter,
        img2: KillerJupiter1,
        title:"Killer Jupiter",
        price:"350"
    },
    {
        img1: KillerPolyester,
        img2: KillerPolyester1,
        title:"Killer Polyester",
        price:"450"
    },
    {
        img1: KillerSprint,
        img2: KillerSprint1,
        title:"Killer Sprint",
        price:"500"
    },
    {
        img1: KillerVespa,
        img2: KillerVespa1,
        title:"Killer Vespa",
        price:"410"
    },
    {
        img1: safari,
        img2: safari1,
        title:"Lenovo",
        price:"300"
    },
    {
        img1: LenovoSlim,
        img2: LenovoSlim1,
        title:"Lenovo Slim",
        price:"370"
    },
    {
        img1: safari2,
        img2: safari3,
        title:"Safari",
        price:"450"
    },
    {
        img1: Wesley,
        img2: Wesley1,
        title:"Wesley",
        price:"350"
    },
    
];
export default Sdata;